import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

const LoginLayout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("token")) navigate(`/home`);
  }, [navigate]);

  return (
    <div className="login_page">
      <div className="login-container">
        <Outlet />
      </div>
    </div>
  );
};

export default LoginLayout;
